import { Spinner } from "@/ui/components/ui/spinner"

// Drop-in replacement for PJ's <JugglingScreen /> placeholder; renders a
// centered spinner. Used between async navigation steps in the auth flow.
export default function LoadingScreen() {
  return (
    <div className="flex min-h-[40vh] items-center justify-center">
      <Spinner className="size-8 animate-spin text-muted-foreground" />
    </div>
  )
}
